import {
    Box,
    chakra,
    Container,
    HStack,
    Image,
    SimpleGrid,
    Stack,
    Text,
    VisuallyHidden,
} from '@chakra-ui/react';
import { FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logo from './assets/images/logo.png';
import { useTranslation } from 'react-i18next';

const Logo = () => {
    return (
        <HStack spacing={8} alignItems="center">
            <Image width={150} src={logo} alt="APA Logo" />
        </HStack>
    );
};

const SocialButton = ({ children, label, href }) => {
    return (
        <chakra.button
            bg="whiteAlpha.200"
            rounded="full"
            w={10}
            h={10}
            cursor="pointer"
            onClick={() => window.open(href, '_blank')}
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            transition="all 0.3s ease"
            _hover={{
                bg: 'whiteAlpha.400',
                transform: 'translateY(-2px)',
            }}
        >
            <VisuallyHidden>{label}</VisuallyHidden>
            {children}
        </chakra.button>
    );
};

const Footer = () => {
    const { t } = useTranslation();

    return (
        <Box
            bg="gray.800"
            color="gray.200"
        >
            <Container as={Stack} maxW="6xl" py={10}>
                <SimpleGrid
                    templateColumns={{ sm: '1fr 1fr', md: '2fr 2fr 2fr 0.5fr' }}
                    spacing={10}
                >
                    <Stack spacing={6}>
                        <Box>
                            <Logo />
                        </Box>
                        <Text color="white" fontSize="sm">
                            {t("Découvrez des réductions instantanées chez nos partenaires, explorez pays et activités, et gérez vos offres depuis l’espace partenaire dédié.")}
                        </Text>
                    </Stack>

                    <Stack color="white" align="flex-start">
                        <Text fontSize="lg" fontWeight="bold" mb={2}>
                            {t("Coordonnées")}
                        </Text>
                        <Text fontSize="sm">
                            N 34 Annakhil Khalij Founty 2 80020 Agadir, Maroc
                        </Text>
                        <Text fontSize="sm">+212 6 08 68 27 78</Text>
                        <Text fontSize="sm">apa.agency.maroc@gmail.com</Text>
                    </Stack>

                    <Stack color="white" align="flex-start">
                        <Text fontSize="lg" fontWeight="bold" mb={2}>
                            {t("Autres pages")}
                        </Text>
                        <Box 
                            as="a" 
                            fontSize="sm" 
                            _hover={{ color: 'cyan.400', textDecoration: 'underline' }}
                            transition="all 0.3s"
                        >
                            <Link to="/Politiques">{t("Politique de Confidentialité")}</Link>
                        </Box>
                        <Box 
                            as="a" 
                            fontSize="sm" 
                            _hover={{ color: 'cyan.400', textDecoration: 'underline' }}
                            transition="all 0.3s"
                        >
                            <Link to="/Conditions">{t("Conditions Générales")}</Link>
                        </Box>
                    </Stack>

                    <Stack 
                        color="white" 
                        align="flex-start" 
                        direction={{ base: "row", md: "column" }} 
                        spacing={4}
                    >
                        <SocialButton href="https://www.facebook.com/apa.agency" label="Facebook">
                            <FaFacebook size={20} />
                        </SocialButton>
                        <SocialButton href="https://www.youtube.com/@apaagencymaroc" label="Youtube">
                            <FaYoutube size={20} />
                        </SocialButton>
                        <SocialButton href="https://www.instagram.com/apa.agency/" label="Instagram">
                            <FaInstagram size={20} />
                        </SocialButton>
                    </Stack>
                </SimpleGrid>
            </Container>

            <Box borderTopWidth={1} borderStyle="solid" borderColor="gray.700">
                <Container
                    as={Stack}
                    maxW="6xl"
                    py={4}
                    direction={{ base: 'column', md: 'row' }}
                    spacing={4}
                    justify="center"
                    align="center"
                    color="gray.300"
                >
                    <Text fontSize="sm">{t("Copyright 2024 © APA Agency")}</Text>
                </Container>
            </Box>
        </Box>
    );
};

export default Footer;